/**
 * Mapping Definition
 *
 * key = vue2 path name / requested by most of the APIs
 * value = vue3 path name / new schema, used in the frontend and also by the client search
 */
export const versicherungsnehmerMapping = {
  salutation_id: 'anredeId',
  firstname: 'vorname',
  lastname: 'nachname',
  title: 'titel',
  birthday: 'geburtsdatum',
  street: 'adresse.strasse',
  street_number: 'adresse.hausnummer',
  zip_code: 'adresse.plz',
  city: 'adresse.ort',
  personal_status: 'familienstand',
  nationality: 'nationalitaet',
  email: 'email',
  phone: 'telefon',
  cellphone: 'mobil',
  placeOfBirth: 'geburtsort',
  countryOfBirth: 'geburtsland',
  birthname: 'geburtsname',
  jobname: 'beruf',
  berufsgruppe: 'berufsgruppe',
  personalverantwortung: 'personalverantwortung',
  weight: 'gewicht',
  height: 'groesse',
  nonSmoker: 'nichtraucher',
  anzahlKinder: 'anzahlKinder',
  commercial_work_percentage: 'anteilTaetigkeitBuero',
  education: 'hoechsterBildungsabschluss',
  gender: 'geschlecht',
  id: 'id',
  fuehrerscheindatum: 'fuehrerscheindatum',
};

export type VersicherungsnehmerMappingKeys =
  keyof typeof versicherungsnehmerMapping;
